import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { GlobalStorage } from 'src/app/global/storage';
import { PresentsService } from 'src/services';
import { Order, Present } from 'src/models';
import { StepType } from 'src/types';
import { ProductType } from '@kokusai/smacere-shared/api';
import { Sorts } from 'src/app/core/utilities/sorts';
import { BundleCartService, BundleType } from '../../../services/bundle-cart.service';

@Component({
  selector: 'app-condolence-video-present',
  templateUrl: './condolence-video-present.component.html',
  styleUrls: ['./condolence-video-present.component.scss'],
})
export class CondolenceVideoPresentComponent implements OnInit {
  @Input()
  From: StepType;

  @Output()
  OnBackScreenEvent: EventEmitter<any> = new EventEmitter<any>();

  private Order: Order = null;
  Presents: Present[] = [];
  selectedPresent?: Present;

  public isEdit: boolean = false;

  constructor(
    private storage: GlobalStorage,
    private presentsService: PresentsService,
    private router: Router,
    private location: Location,
    private bundleCartService: BundleCartService
  ) {}

  ngOnInit(): void {
    this.bundleCartService.checkStep(BundleType.CondolenceVideo, 'present');

    this.Order = this.storage.Order;
    this.presentsService
      .gets(
        ProductType.CondolenceVideo,
        this.Order.CondolenceVideoOrder.Product.price,
        this.storage.Funeral.funeralDate
      )
      .subscribe((presents: Present[]) => {
        this.Presents = presents.sort((a, b) => {
          return Sorts.byJapanAlpha(a, b, 'name');
        });
      });

    if (this.Order.CondolenceVideoPresent) {
      this.selectedPresent = this.Order.CondolenceVideoPresent;
    } else {
      this.Order.CondolenceVideoPresent = new Present();
    }
    this.isEdit = this.bundleCartService.isEdit();
  }

  private async save(): Promise<boolean> {
    if (!this.selectedPresent) {
      await Swal.fire({
        icon: 'warning',
        title: '弔電返礼品が未選択です',
        text: '返礼品一覧より、ご選択ください',
      });
      return false;
    }

    this.Order.CondolenceVideoPresent = this.selectedPresent;
    this.storage.Order = this.Order;
    await this.bundleCartService.saveCondolenceVideoFromStorage();

    return true;
  }

  public async saveAction(): Promise<void> {
    if (await this.save()) {
      await this.bundleCartService.goToNextStep(BundleType.CondolenceVideo);
    }
  }

  OSelectChange(value: Present): void {
    this.selectedPresent = value;
  }

  public async addAction(): Promise<void> {
    if (await this.save()) {
      await this.bundleCartService.goToAdd(BundleType.CondolenceVideo);
    }
  }

  back(): void {
    this.location.back();
  }
}
